import React from "react";
import { Helmet } from "react-helmet";

const Seo = ({ title, description, keywords, canonical }) => {
  return (
    <Helmet>
      {/* Dynamic Page Title */}
      <title>Tech Ayukta - {title}</title>

      {/* Meta Tags */}
      <meta name="description" content={description || "Tech Ayukta - IT Solutions & Services"} />
      <meta name="keywords" content={keywords || "IT Solutions, Web Development, App Development, ERP, Consulting"} />
      <meta name="robots" content="index, follow" />

      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph (for Social Media SEO) */}
      <meta property="og:title" content={`Tech Ayukta - ${title}`} />
      <meta property="og:description" content={description || "Tech Ayukta - IT Solutions & Services"} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content="/favicons/android-icon-192x192.png" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`Tech Ayukta - ${title}`} />
      <meta name="twitter:description" content={description || "Tech Ayukta - IT Solutions & Services"} />
      <meta name="twitter:image" content="/favicons/android-icon-192x192.png" />
    </Helmet>
  );
};

export default Seo;

